<template lang="pug">
    generic-upload-control.media-vault-upload-control(v-bind="$attrs" :value="value" :allowVideo="true" :uploadHandler="uploadHandler" @input="input" @clickFile="clickFile" ref="uploadControl" mode="inline")
</template>

<script>
import MediaVaultService from '../../services/media-vault-service'

export default {
    name: 'media-vault-upload-control',
    props: {
        value: {
            type: Array,
        },
    },
    methods: {
        uploadHandler(file, progressCb) {
            return MediaVaultService.store({
                file,
                progressCb,
            })
        },

        input(...args) {
            this.$emit('input', ...args)
        },

        clickFile(...args) {
            this.$emit('clickFile', ...args)
        },

        removeFile(file) {
            this.$refs.uploadControl.removeFile(file)
        },

        // uploadFile(...args) {
        //     this.$refs.uploadControl.uploadFile(...args)
        // },

        // setFiles(files) {
        //     this.$refs.uploadControl.setFiles(files)
        // },

        // clickDropzone(...args) {
        //     this.$refs.uploadControl.clickDropzone(...args)
        // },
    },
}
</script>
